import { createVNode as n, mergeProps as a } from "vue";
import l from "../node_modules/@pf-ui/pf-icon-svg/es/asn/InternalErrorTwoTone.js";
import m from "../components/PfIcon.js";
const r = (o, e) => {
  const t = {
    ...o,
    ...e.attrs
  };
  return n(m, a(t, {
    icon: l
  }), null);
};
r.displayName = "InternalErrorTwoTone";
r.inheritAttrs = !1;
export {
  r as default
};
